import CourseCascader from './course-cascader.vue';

export default {
  install(application) {
    application.component('yx-course-cascader', CourseCascader);
  },
};
